import { YardBlockSlotOccupanciesApi, YardPositionDto } from '@storage/app/api'

export class YardBlockSlotOccupancyService {
  constructor(private api: YardBlockSlotOccupanciesApi) {}

  async validateDGStackingAndSegregationRulesViolation(
    containerTurnoverId: string,
    location: YardPositionDto,
    isAdminAction = false,
  ): Promise<void> {
    await this.api.yardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolation({
      createYardPositionDto: {
        containerTurnoverId,
        location,
        isAdminAction,
      },
    })
  }

  async updateContainerPosition(
    containerTurnoverId: string,
    location: YardPositionDto,
    isAdminAction: boolean,
  ): Promise<void> {
    await this.api.yardBlockSlotOccupanciesUpdateContainerPosition({
      createYardPositionDto: {
        containerTurnoverId,
        location,
        isAdminAction,
      },
    })
  }
}
